var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1500 1500" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1500 1500",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "m13.7 109.1 13.7-6.7V89L13.7 75.3 0 89v13.4zM13.7 0l2.4 36.7h-4.9zM15.7 33.2h-4.9z",
          transform: "rotate(-71.997 620.636 -300.423) scale(2.23027 -2.26431)",
        },
      }),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "m8.7 59.6-.1-34.3c0-2.8 2.2-5 5-5 2.7 0 5 2.2 5 5l.1 34.4-10-.1z",
          transform: "rotate(-71.997 620.636 -300.423) scale(2.23027 -2.26431)",
        },
      }),
      _c("defs", [
        _c("path", {
          attrs: {
            id: "SVGID_1_",
            d: "M-2766.8 3695.1h1659.5v1440.7h-1659.5z",
          },
        }),
      ]),
      _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#SVGID_1_" },
        }),
      ]),
      _c(
        "g",
        {
          staticStyle: { "clip-path": "url(#SVGID_2_)" },
          attrs: { transform: "matrix(-2.98479 0 0 2.98286 1394 927)" },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: {
                id: "SVGID_3_",
                d: "M-736.7-1089.4H922.8v2454.9H-736.7z",
              },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_4_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_3_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_4_)" } }, [
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "M98.3 6.4H88V240c0 1.7 1.3 3 3 3h4.4c1.7 0 3-1.3 3-3L98.3 6.4z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "M97.7 18.1 88 21.5l88.4 252.4c.5 1.6 2.3 2.4 3.8 1.8l4.1-1.4c1.6-.5 2.4-2.3 1.8-3.8L97.7 18.1z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "m88.5 18.1 9.8 3.4L10 273.9c-.5 1.6-2.3 2.4-3.8 1.8L2 274.3c-1.6-.5-2.4-2.3-1.8-3.8L88.5 18.1z",
              },
            }),
            _c("path", {
              staticClass: "st3",
              attrs: {
                d: "M153.6 197.5H31.9c-.9 0-1.7-.6-1.9-1.5s.2-1.8 1-2.2L91.8 161c.6-.3 1.3-.3 1.9 0l60.9 32.8c.8.4 1.2 1.4 1 2.2s-1 1.5-2 1.5zm-113.8-4h105.9L92.8 165l-53 28.5zM110.7 7.8H75.6c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2h35.1c1.1 0 2 .9 2 2v3.8c0 1.1-.9 2-2 2z",
              },
            }),
          ]),
        ]
      ),
      _c("g", [
        _c("g", [
          _c("circle", {
            staticClass: "st4",
            attrs: { cx: "1116", cy: "715", r: "355" },
          }),
          _c("circle", {
            staticStyle: { fill: "#fff" },
            attrs: { cx: "1116", cy: "715", r: "230.8" },
          }),
          _c("circle", {
            staticClass: "st4",
            attrs: { cx: "1116", cy: "715", r: "88.8" },
          }),
          _c("path", {
            staticStyle: {
              opacity: ".51",
              fill: "#fff",
              "enable-background": "new",
            },
            attrs: {
              id: "texure_2_-i2",
              d: "M1083.2 610.3c-.9 0-2.7 0-3.6-1.8-.9-1.8 0-2.7 1.8-3.5.9 0 2.7 0 3.6 1.8-.1.8-.9 2.6-1.8 3.5zm-19.6-57.7c-1.8 0-2.7 0-3.5-1.8 0-.9 0-2.7 1.8-2.7.9-.9 2.7 0 2.7.9.8 1.8.8 2.7-1 3.6zm-232.5 38.2c-.9.9-1.8 1.8-3.5.9-.9-.9-1.8-1.8-.9-2.7.9-.9 1.8-1.8 3.6-.9.8-.9.8.9.8 2.7zm345.2-71.9c-.9.9-2.7.9-3.6 0-.9-.9-.9-2.7 0-3.5.9-.9 2.7-.9 3.6 0 1.8.8 1.8 2.6 0 3.5.9 0 0 0 0 0zm-217.4 72.7c0 1.8-1.8 2.7-2.7 2.7-1.8 0-2.7-1.8-2.7-2.7 0-1.8 1.8-2.7 2.7-2.7 1.8 1 2.7 1.9 2.7 2.7zm4.4-60.3c0 1.8-1.8 2.7-2.7 1.8-.9 0-2.7-.9-2.7-2.7 0-1.8 1.8-2.7 2.7-2.7 1.9 1.8 2.7 2.7 2.7 3.6zm446.5 118c-1.8 1.8-4.4 1.8-6.2 0-1.8-1.8-1.8-4.4 0-6.2 1.8-1.8 4.4-1.8 6.2 0 1.7 1.8 1.7 4.4 0 6.2zm-80.8-81.6c-1.8 1.8-4.4 1.8-7.1 0-1.8-1.8-1.8-4.4 0-7.1 1.8-1.8 4.4-1.8 6.2 0 2.7 2.6 2.7 5.3.9 7.1zm-283.1 342.5c0 2.7-1.8 4.4-4.4 4.4s-4.4-1.8-4.4-4.4c0-2.7 1.8-4.4 4.4-4.4 1.7 0 4.4 1.8 4.4 4.4zm.9-228.9c0 2.7-1.8 4.4-4.4 4.4-2.7 0-4.4-1.8-4.4-4.4 0-2.7 1.8-4.4 4.4-4.4 2.6-.9 4.4 1.7 4.4 4.4zm.9-115.4c0 2.7-1.8 4.4-4.4 4.4s-4.4-1.8-4.4-4.4c0-2.7 1.8-4.4 4.4-4.4 1.7 0 4.4 1.7 4.4 4.4zm223.6 248.5c-2.7.9-5.3 0-6.2-2.7-.9-2.7 0-5.3 2.7-6.2s5.3 0 6.2 2.7c.9 2.6-.9 5.3-2.7 6.2zm-43.5-105.6c-2.7.9-5.3 0-6.2-2.7-.9-2.7 0-5.3 2.7-6.2 2.7-.9 5.3 0 6.2 2.7.9 1.7 0 4.4-2.7 6.2zm-43.5-106.5c-2.7.9-5.3 0-6.2-2.7-.9-2.7 0-5.3 2.7-6.2s5.3 0 6.2 2.7c.9 2.6 0 5.3-2.7 6.2zM835.5 813.5c-.9 2.7-3.5 3.5-6.2 2.7-2.7-.9-3.5-3.6-2.7-6.2.9-2.7 3.6-3.5 6.2-2.7 2.7.9 3.6 4.4 2.7 6.2zm88.8-211.2c-.9 2.7-3.5 3.5-6.2 2.7-2.7-.9-3.6-3.6-2.7-6.2.9-2.7 3.6-3.5 6.2-2.7s3.6 3.5 2.7 6.2zm449.1 166.8c-1.8.9-4.4 0-5.3-1.8-.9-1.8 0-4.4 1.8-5.3 1.8-.9 4.4 0 5.3 1.8 1.7 1.8.8 4.4-1.8 5.3zm-47.1-90.5c-1.8.9-4.4 0-5.3-1.8-.9-1.8-.9-4.4 1.8-5.3 1.8-.9 4.4-.9 5.3 1.8.9 1.8 0 4.4-1.8 5.3zm-46.1-93.2c0 .9-.9 1.8-1.8 2.7-1.8.9-4.4 0-5.3-1.8-.9-1.8 0-4.4 1.8-6.2.9-.9 2.7-.9 4.4 0 .9 0 .9.9 1.8 1.8 0 1.8 0 2.6-.9 3.5zM947.4 805.5c-.9 2.7-3.5 3.5-5.3 2.7-1.8-.9-3.5-2.7-2.7-5.3.9-2.7 2.7-3.5 5.3-2.7 2.7.9 3.6 3.6 2.7 5.3zm61.2-195.2c-.9 2.7-2.7 3.5-5.3 2.7-1.8-.9-3.6-2.7-2.7-4.4.9-2.7 2.7-3.5 5.3-2.7 1.8-.1 2.7 2.6 2.7 4.4zm30.2-97.6c-.9 2.7-3.6 3.5-5.3 2.7-1.8-.9-3.6-2.7-2.7-5.3.9-1.8 2.7-3.5 5.3-2.7 1.8.8 2.7 3.5 2.7 5.3zm130.4 262.6c0 2.7-1.8 4.4-3.6 4.4-2.7 0-4.4-1.8-4.4-3.5 0-2.7 1.8-4.4 3.6-4.4 2.7 0 4.4 1.8 4.4 3.5zm-8.8-101.1c0 1.8-.9 4.4-3.6 4.4s-4.4-1.8-4.4-3.5c0-2.7 1.8-4.4 3.6-4.4 1.7-1 4.4.8 4.4 3.5zm-9.8-102.1c0 2.7-1.8 4.4-3.6 4.4-2.7 0-4.4-1.8-4.4-3.5 0-2.7 1.8-4.4 3.6-4.4 2.6-.9 4.4.9 4.4 3.5zm-291.1 15.1c-1.8 1.8-4.4 1.8-6.2.9-1.8-1.8-1.8-4.4 0-6.2 1.8-1.8 4.4-1.8 6.2-.9s1.8 3.5 0 6.2c0-.9 0 0 0 0zm284-1.8c0 1.8-1.8 2.7-2.7 1.8-1.8 0-2.7-1.8-1.8-2.7 0-1.8 1.8-2.7 2.7-1.8.9.1 1.8 1 1.8 2.7zm6.2-60.3c0 1.8-1.8 2.7-2.7 1.8-1.8 0-2.7-1.8-1.8-2.7 0-.9.9-2.7 2.7-1.8.9 0 1.8 1.8 1.8 2.7zm113.6 18.6c-.9 0-2.7 0-2.7-1.8 0-.9 0-2.7 1.8-2.7.9 0 2.7 0 2.7 1.8.9.9 0 2.7-1.8 2.7zm-227.2-23.9c-.9.9-1.8 1.8-3.6.9-.9-.9-1.8-1.8-.9-3.5.9-.9 1.8-1.8 2.7-.9 1.8.8 1.8 1.7 1.8 3.5zm387.9 59.4c-.9.9-2.7 0-3.6-.9-.9-.9 0-2.7.9-3.5.9-.9 2.7 0 3.5.9 1.8.8.9 2.6-.8 3.5zm-286.7 27.5c0 1.8-1.8 2.7-3.6 1.8-1.8-.9-2.7-1.8-1.8-3.5.9-1.8 1.8-2.7 3.6-1.8 1.8 0 2.7 1.8 1.8 3.5zm20.4-65.7c-.9 1.8-1.8 2.7-3.6 1.8-1.8-.9-2.7-1.8-1.8-3.5.9-1.8 1.8-2.7 3.6-1.8.9 0 1.8 1.8 1.8 3.5zm122.5 44.4h-.9c-1.8 0-2.7-.9-2.7-2.7 0-1.8.9-2.7 2.7-3.5 1.8 0 2.7.9 2.7 2.7 0 2.6 0 3.5-1.8 3.5zM1029 511.8c-.9.9-2.7 1.8-3.6 0-.9-.9-1.8-2.7 0-3.6.9-.9 2.7-1.8 3.6-.9 0 .9.9 2.7 0 4.5zm339.1 365.6c0 2.7-1.8 5.3-4.4 5.3-2.7 0-5.3-1.8-5.3-4.4s1.8-5.3 4.4-5.3 4.4 1.8 5.3 4.4zm-9.8-117.1c0 2.7-1.8 5.3-4.4 5.3s-5.3-1.8-5.3-4.4 1.8-5.3 4.4-5.3c2.6-1 4.4 1.7 5.3 4.4zm-9.8-118.1c0 2.7-1.8 5.3-4.4 5.3s-5.3-1.8-5.3-4.4 1.8-5.3 4.4-5.3c2.7 0 5.3 1.8 5.3 4.4zm-378-3.5c-1.8 1.8-4.4 2.7-7.1.9-1.8-1.8-2.7-4.4-.9-7.1 1.8-1.8 4.4-2.7 7.1-.9 1.7 1.7 2.6 5.3.9 7.1zm76.3-89.7c-1.8 1.8-4.4 2.7-7.1.9-1.8-1.8-2.7-5.3-.9-7.1 1.8-1.8 5.3-1.8 7.1 0 1.8.9 2.7 3.6.9 6.2zm130.4 138.5c-.9 2.7-3.6 4.4-6.2 3.6-2.7-.9-3.6-3.6-2.7-6.2.9-2.7 3.5-4.4 6.2-3.5 1.8.8 3.6 3.4 2.7 6.1zm36.4-111.8c-.9 2.7-3.6 3.5-6.2 3.5-2.7-.9-4.4-3.5-3.5-6.2.9-2.7 3.5-4.4 6.2-3.5 2.6 0 3.5 2.6 3.5 6.2 0-.9 0-.9 0 0zm27.5 154.4c-.9 2.7-3.5 4.4-6.2 3.5-2.7-.9-4.4-3.5-3.6-6.2.9-2.7 3.6-4.4 6.2-3.5s3.6 3.5 3.6 6.2zm31.1-113.6c-.9 2.7-3.5 4.4-6.2 3.5-2.7-.9-4.4-3.5-3.6-6.2.9-2.7 3.6-4.4 6.2-3.6 2.7 1 3.6 3.6 3.6 6.3zm171.3 63c0 2.7-1.8 5.3-4.4 5.3-2.7 0-5.3-1.8-5.3-4.4 0-2.7 1.8-5.3 4.4-5.3s5.3 1.7 5.3 4.4zm-14.2-117.2c0 2.7-1.8 5.3-4.4 5.3s-5.3-1.8-5.3-4.4c0-2.7 1.8-5.3 4.4-5.3s4.4 1.8 5.3 4.4zM1022.8 683c-1.8 1.8-4.4 2.7-7.1.9-1.8-1.8-2.7-4.4-.9-7.1 1.8-1.8 4.4-2.7 6.2-.9 2.7 1.8 3.6 5.4 1.8 7.1zm71.9-92.2c-1.8 1.8-4.4 2.7-7.1.9-1.8-1.8-2.7-4.4-.9-7.1 1.8-1.8 4.4-2.7 6.2-.9 3.6 1.7 3.6 4.4 1.8 7.1zm126.9 49.7c-.9 1.8-3.6 2.7-5.3 1.8-1.8-.9-2.7-2.7-1.8-4.4.9-1.8 2.7-2.7 4.4-1.8 3.6.8 3.6 2.6 2.7 4.4zm40.8-78.2c-.9 1.8-3.6 2.7-5.3 1.8-1.8-.9-2.7-3.5-1.8-5.3.9-1.8 3.5-2.7 4.4-1.8 3.6.9 3.6 3.6 2.7 5.3zm147.4 83.5c0 1.8-1.8 3.5-3.5 3.5s-3.6-1.8-3.6-4.4c0-1.8 1.8-3.5 3.6-3.5 2.6.8 3.5 1.7 3.5 4.4zm8-88.8c0 1.8-1.8 3.5-4.4 3.5-1.8 0-3.6-1.8-3.6-3.5 0-1.8 1.8-3.5 3.6-3.5 2.6 0 4.4 1.7 4.4 3.5z",
            },
          }),
        ]),
      ]),
      _c("path", {
        staticStyle: { fill: "none" },
        attrs: { d: "M312.5 345.9h1479.7V3933H312.5z" },
      }),
      _c("g", [
        _c(
          "g",
          { attrs: { transform: "matrix(2.72 0 0 2.71959 84 93)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_hand_1_-i3_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "984.19",
                  y1: "337.235",
                  x2: "518.785",
                  y2: "1058.949",
                  gradientTransform: "matrix(.5484 0 0 .548 -350.2 -92.929)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_hand_1_-i3_1_)" },
              attrs: {
                id: "R_hand_1_-i3",
                d: "M155 128.8s16.6-15.1 19.2-27.9c2.6-12.7 1.7-21.2 6.1-23.6 4.4-2.4 17.4-4.2 19.1-4.7 1.3-.4 1.1 2.4-4.8 4.5 0 0 3.5 1.8 4.2 8 .8 6.2-5 .3-6.2 1.4s.9 8.2-6.4 12.6-6.8 41.3-19.7 58.1c0 .1-10.6-28.5-11.5-28.4-.9.2 11.5 28.5 11.5 28.5",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck-2-i3_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "761.248",
                  y1: "356.892",
                  x2: "841.068",
                  y2: "-156.233",
                  gradientTransform: "matrix(.5484 0 0 .548 -350.2 -92.929)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck-2-i3_1_)" },
              attrs: {
                id: "neck-2-i3",
                d: "M79.8 66.9c-.9 4.8-1 9.7-.5 14.6 0 0-6.5 5.2-16.9-4.2l5.2-17.6 12.2 7.2",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#ffbeb6" },
              attrs: {
                id: "face-2-i3",
                d: "M94.4 32.2c.1.1.1.2.1.3l.6 1.5c2 5.5 7.1 8.9 7.5 10.4s-2.4 3.3-3.8 3.8-1.5 8.1-6.4 13.6c-4.6 5.2-13 6.6-19.2 4.8-4.9-11.5-6.5-20.1 3.9-28.2C88.4 29.6 88 23.8 88 23.8c2.7 2.3 4.9 5.2 6.4 8.4z",
              },
            }),
            _c("circle", {
              staticClass: "st4",
              attrs: { id: "hair-2-i3", cx: "42.6", cy: "12.3", r: "33.5" },
            }),
            _c("path", {
              staticStyle: { fill: "#1c2868" },
              attrs: {
                id: "eye-i3",
                d: "M91.1 37.6c2 1.5 4.7 1 6.2-.9.5-.7.8-1.6.9-2.5 0-.7-1-.8-1-.2 0 1.9-1.5 3.4-3.4 3.4-.7 0-1.4-.2-2-.6s-1.3.4-.7.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_shoe-2-i3_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-1187.378",
                  y1: "1021.135",
                  x2: "66.9",
                  y2: "1021.135",
                  gradientTransform: "matrix(-.5484 0 0 .548 -497.885 -92.929)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#28306d" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#1f275f" },
                  attrs: { offset: ".51" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#171f51" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_shoe-2-i3_1_)" },
              attrs: {
                id: "L_shoe-2-i3",
                d: "M73.3 448.3h28.4s14.8 13.9 30.7 20.7 20.7 16 20.7 16H60.2l13.1-36.7",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#28306d" },
              attrs: {
                id: "R_shoe-2-i3",
                d: "M13.2 448.3h30.2s13 13.9 28.9 20.7c15.9 6.8 20.7 16 20.7 16H0l13.2-36.7",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#0d94c6" },
              attrs: {
                id: "L_trousers-2-i3",
                d: "M101.7 448.3H73.3c-21-20.6-17-55-18.5-87.7-1.6-32.7.8-19.7-3.4-50.6-5.2-38.9-3.5-32.2-13.6-76.6-2.6-10.7-3.9-21.7-3.8-32.7.1-1 .2-1.9.3-2.8 2.7.2 5.6.3 8.6.3 14.7.1 29.3-2.2 43.3-6.8 1.7 15.7 5 45 5 45.5 1.1 7.4 1.7 11.8 3.9 24.5.2 1 .3 2 .4 3.1 1.9 18 4.3 46.6 4.7 71 .7 28.3 1.5 112.8 1.5 112.8z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#1A7BEE" },
              attrs: {
                d: "M96.9 314.6c-2.3 22.6-53.5 133.7-53.5 133.7H13.2s1-36.4 4.7-55.5 10.6-15.2 9.2-30C25.8 348 29 338.5 35 322.9s19.9-23 1.4-74.7c-6-16.9-10-38.3-8.9-50.9 5.1.6 10.3.9 15.5 1 15.5.1 31-2.5 45.7-7.6l4.5 44.4c.3 2.8.6 5.2 1 7.9 3.1 22.1 5 49 2.7 71.6z",
              },
            }),
            _c("path", {
              staticStyle: {
                opacity: ".86",
                fill: "#fff",
                "enable-background": "new",
              },
              attrs: {
                id: "texture-2-i3",
                d: "M31.6 209.7c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3s.2.2.3.1c.1-.1.2-.2.1-.3zm-1.9-4.7c0-.1-.1-.2-.3-.1-.1 0-.2.2-.1.3s.2.2.3.1c.1-.1.1-.2.1-.3zm-2-4.8c0-.1-.2-.2-.3-.1-.1.1-.2.2-.1.3 0 .1.2.2.3.1.1 0 .1-.1.1-.3zm11.2 1.2c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0c.1-.1.1-.2 0-.3zm20.5 9.3c-.2-.1-.4-.1-.6 0-.1.2-.1.4 0 .6.2.1.4.1.6 0 .2-.2.1-.5 0-.6zm-7.4-6.4c-.2-.1-.4-.1-.6 0-.1.2-.1.4 0 .6.2.1.4.1.6 0 .2-.2.2-.5 0-.6zm-22.1 30.9c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.4-.4-.4zm-.7-9.7c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4zm-.7-9.7c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4zm20.4 9.7c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2c.2 0 .3-.3.2-.5zm-4.3-8.7c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2c.2 0 .3-.3.2-.5zm-4.3-8.7c-.1-.2-.4-.3-.6-.2-.2.1-.3.4-.2.6.1.2.3.3.5.2.3-.1.3-.3.3-.6zm-4.4-8.6c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5c.1.2.3.3.5.2.2-.1.3-.3.2-.5zm21.3 21.6c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1.2-.3.1-.5zm-4.5-7.4c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.2-.3.1-.5 0 .1 0 0 0 0zm-4.6-7.3c0-.1-.1-.1-.1-.1h-.3c-.2.1-.2.3-.1.5s.3.2.5.1c.1 0 .1-.1.1-.2-.1-.1-.1-.2-.1-.3zm-4.6-7.4c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.2-.3.1-.5zm-16.6 2.6c-.2 0-.4.1-.4.3s.1.4.3.4c.2 0 .4-.1.4-.3 0-.1-.1-.3-.3-.4zm33.8-1.3c-.2-.1-.4-.1-.5.1-.1.1-.1.4.1.5.2.1.4.1.5-.1.1-.1 0-.3-.1-.5zm-21.2 22.8c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.4-8.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c-.1-.2-.2-.4-.4-.3zm-1.5-8.6c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm20-6.2c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0c.1-.1.1-.2 0-.3zm-20.3 7.5c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.2-5.1c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm10 .8c0-.1-.1-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.2.2.3.1.1-.1.2-.2.1-.3zm-19.6-.6c-.1-.1-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.2 0-.3-.1-.3zm2.1-4.7c-.1-.1-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3zm31.3 7.1c-.1-.1-.2-.1-.3-.1-.1.1-.2.2-.1.3.1.1.2.1.3.1.1 0 .2-.1.1-.3zm-3.2-4.9c-.1-.1-.2-.1-.3-.1-.1.1-.2.2-.1.3.1.1.2.1.3.1.2 0 .2-.1.1-.3.1 0 0 0 0 0zM36 209c-.1 0-.3.1-.3.2s0 .3.2.3c.1 0 .2 0 .3-.2 0-.1-.1-.2-.2-.3zm1.2-5.7c-.1 0-.3.1-.3.2s0 .3.2.3c.1 0 .3 0 .3-.2 0-.1 0-.2-.2-.3zm11 3.1c0-.1-.1-.2-.3-.2-.1 0-.2.2-.2.3s.1.2.3.2h.1c.1-.1.1-.2.1-.3zm-1.3-5.9c-.1 0-.2.2-.2.3s.2.2.3.2.2-.1.2-.3c-.1-.1-.2-.2-.3-.2zm9.9 29.9c-.2 0-.4.2-.4.5 0 .2.2.4.5.3.2 0 .4-.2.4-.5 0-.1-.2-.3-.5-.3zm-1.5-9.8c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5-.1-.2-.3-.4-.5-.3zm-1.6-9.9c-.2 0-.4.2-.4.5 0 .2.2.4.5.4.2 0 .4-.2.4-.5s-.2-.5-.5-.4zm-1.5-9.9c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5-.1-.2-.3-.3-.5-.3zm12.7 1.2c-.1-.2-.4-.3-.6-.1-.2.1-.3.4-.1.6.1.2.4.3.6.1.2-.1.2-.4.1-.6zm-27.6 23.2c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2 0 .4-.1.5-.3.1-.3 0-.5-.3-.5zm2.4-9.8c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2.1.5-.1.5-.3 0-.2-.1-.4-.3-.5zm2.3-9.7c-.2 0-.4.1-.5.3 0 .2.1.4.3.5s.4-.1.5-.3c.1-.2-.1-.4-.3-.5zm1.4 22.7c-.2 0-.4.1-.5.3s.1.4.3.5.4-.1.5-.3-.1-.5-.3-.5zm1.9-9.8c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.1-.2-.1-.4-.3-.5zm1.9-9.7c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.1-.3 0-.5-.3-.5zm2-9.8c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.3-.1-.5-.3-.5zM62 213.2c-.2 0-.4.3-.3.5 0 .2.3.4.5.3.2 0 .4-.3.3-.5-.1-.2-.3-.3-.5-.3zm-2-9.8c-.2 0-.4.3-.3.5 0 .2.3.4.5.3.2 0 .4-.3.3-.5 0-.1-.2-.3-.5-.3zm-27.7 4.3c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.2-.2.1-.5-.1-.6zm5.5-8.3c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.2-.2.1-.5-.1-.6zm5.5 11.9c-.1-.1-.3 0-.4.1-.1.2 0 .3.2.4s.3 0 .4-.2c.1-.1 0-.2-.2-.3zm3-6.9c-.2-.1-.3 0-.4.2-.1.2 0 .3.2.4.2.1.3 0 .4-.2 0-.2-.1-.4-.2-.4zm12.8 6.2c-.2 0-.3.1-.3.3 0 .2.1.3.3.3s.3-.1.3-.3c0-.1-.1-.3-.3-.3zm.1-7.5c-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm-26.4-3.5c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0s.1-.3 0-.4zm23.6 1c-.1-.1-.3 0-.4.1-.1.1-.1.3.1.4.1.1.3.1.4-.1.1-.1.1-.3-.1-.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "sweater-2-i3_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "672.644",
                  y1: "377.599",
                  x2: "2674.869",
                  y2: "2412.116",
                  gradientTransform: "matrix(.5484 0 0 .548 -350.2 -92.929)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#1e2361" },
                  attrs: { offset: ".353" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#sweater-2-i3_1_)" },
              attrs: {
                id: "sweater-2-i3",
                d: "M105 183.7c-19.2 9.7-40.5 14.7-62 14.5-23.7-.1-39.6-6.3-39.6-6.3s-4.5-15.3 5.9-33.4c17.5-30.3 6.2-13.8 19.3-40 4.9-9.4 10.9-18.2 17.9-26.1 4.9-5.5 10.2-10.5 16-15.1 8.7 7.9 14.7 5.5 16.4 4.5.1 2.1.2 4.2.4 6.3 2.2 28.5 12.5 57.3 18.4 75.4.3 1 .7 2 1 3 3.6 10.7 6.3 17.2 6.3 17.2z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_sleeve-3-i3_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "823.649",
                  y1: "432.608",
                  x2: "2901.01",
                  y2: "1530.487",
                  gradientTransform: "matrix(.5484 0 0 .548 -350.2 -92.929)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#1e2361" },
                  attrs: { offset: ".353" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_sleeve-3-i3_1_)" },
              attrs: {
                id: "R_sleeve-3-i3",
                d: "M180.8 174.1s-19 20.2-37.5 16.1c-16.9-3.8-18.4.7-26.4 2.6-.8.2-1.5.4-2.4.6-9.2 2.4-31 2.6-43.4-25.5C59 140.5 55.4 117 62.6 77.5c10.3 9.3 16.8 4.1 16.8 4.1 0-.4-.1-.9-.1-1.3 2.3 4.3 13.2 24.6 23.8 39 11.9 16.2 15.7 18 32.4 13.5 2.8-.7 5.3-1.5 7.7-2.1 9.1-2.6 14.8-4.5 14.8-4.5l22.8 47.9z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: {
                id: "hair-3-i3",
                d: "M94.6 32.6c-2.2-19.4-20.7-20.2-34.8-17.2-7.4 1.5-12.2 4.9-15.2 8.9-5.6 2.1-11.9-.5-14.5-5.9-.3-.5-1-.1-.8.5 2.6 5.4 8.7 8.2 14.5 6.7-2 3-3.1 6.5-3.3 10.1-.2 4-.9 11.6-5.3 18.1s-4.5 17.9-4.5 17.9c21.5 7.9 49.2-3.1 49.2-3.1.3-12.8-6.6-16.9-3.2-23.8-.5 1.7-.6 3.6-.2 5.4 1.3 6.4 8 11.3 5.1 18.3-.2.5.6.8.9.2 1.4-3.3.9-6.3-.6-9.5-1.1-2.4-2.7-4.5-3.6-6.9-1.5-3.7-1-8 1.2-11.3 9.5-10.7 8.7-16.9 8.7-16.9 2.6 2.1 4.8 5.1 6.4 8.5z",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }